import _ from 'lodash';
import React, { Component } from 'react';
import { connect } from 'react-redux';

import {
  Firebase,
  isDevelopment
} from './../../util';

class AssessmentLogin extends Component {

  state = {
    email: '',
    password: '',
    signupError: null,
    signupMessage: null,
    syncingWithServer: false,
  }

  handleSubmit(event){
    event.preventDefault();
    this.submitSignupForm();
  }

  getSignupButtonHtml(){
    return {
      __html: (this.state.syncingWithServer ? 'Signing up...' : 'Signup')
    };
  }

  submitSignupForm(){

    this.setState({
      syncingWithServer: true,
      signupError: false
    });

    const {email, password} = this.state;

    Firebase.auth().createUserWithEmailAndPassword(email, password).catch(error => {
      this.setState({
        syncingWithServer: false,
        signupError: error.message,
      });
    }).then(() => {
      //PublicUsersRef().doc()
      console.log('firebase signup THEN!');
      // this.setState({
      //   redirectToReferrer: true,
      // });
    });
  }

  renderSignupForm(){

    const {
      email,
      password,
      syncingWithServer,
      signupError,
      signupMessage,
      resettingPassword,
      resetPasswordComplete
    } = this.state;

    return (
      <form onSubmit={this.handleSubmit.bind(this)}>
        <div className="velocity-form page-form">
          <h2>Create Account</h2>
          {signupError &&
            <div className="form-message error">{signupError}</div>
          }
          {signupMessage &&
            <div className="form-message success">{signupMessage}</div>
          }
          <div className="form-group">
            <label htmlFor="velocity-login-email">Email</label>
            <input ref={input => { this.emailInput = input; }} id="velocity-login-email" disabled={syncingWithServer} type="text" placeholder="Email" value={email} onChange={(e) => this.setState({ email: e.target.value }) } />
          </div>
          <div className="form-group">
            <label htmlFor="velocity-login-password">Password</label>
            <input ref={input => { this.passwordInput = input; }} id="velocity-login-password" disabled={syncingWithServer} type="password" placeholder="Password" value={password} onChange={(e) => this.setState({ password: e.target.value }) } />
          </div>
          <div className="form-group">
            <button className={'button primary' + (syncingWithServer ? ' disabled' : '')} disabled={syncingWithServer} onClick={this.submitSignupForm.bind(this)} dangerouslySetInnerHTML={this.getSignupButtonHtml()}></button>
          </div>
          <div className="form-group">
            <p className="forgot-password actionable centered" onClick={this.props.showLoginForm}>I already have an account...</p>
          </div>
        </div>
      </form>
    )
  }

  render(){
    return (
      <div className="page login">
        {this.renderSignupForm()}
      </div>
    )
  }
}

function mapStateToProps(state){
  return {
    user: state.user,
  }
}

export default connect(mapStateToProps, {})(AssessmentLogin);



// WEBPACK FOOTER //
// ./src/components/takeAssessment/assessmentSignup.js